let exportDesktopLayout = false;
const listeners = new Set();

export function subscribeChartExportDesktopLayout(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getChartExportDesktopLayout() {
  return exportDesktopLayout;
}

export function getChartExportDesktopLayoutServerSnapshot() {
  return false;
}

export function setChartExportDesktopLayout(value) {
  if (exportDesktopLayout === value) return;
  exportDesktopLayout = value;
  listeners.forEach((cb) => cb());
}
